// miniGamesUI.js
var MiniGamesUi = pc.createScript('miniGamesUi');

MiniGamesUi.attributes.add("EventsItems", {type: "entity", array: true});
MiniGamesUi.attributes.add("EventCloseButton", {type: "entity"});
MiniGamesUi.attributes.add("ContentLayout", {type: "entity"});


MiniGamesUi.prototype.initialize = function () {

    this.checkLevelStatusForGame();    

    this.EventsItems[0].button.once('click', function (event) {
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "MathGameButton:Click", 1);}
        this.loadMiniGameScene(1);

    }, this);

    this.EventsItems[1].button.once('click', function (event) {
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "AttentionGameButton:Click", 1);}
        this.loadMiniGameScene(4);
    }, this);

    this.EventsItems[2].button.once('click', function (event) {
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "WordGameButton:Click", 1);}
        this.loadMiniGameScene(2);
    }, this);

    this.EventsItems[3].button.once('click', function (event) {
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "LinkGameButton:Click", 1);}
        this.loadMiniGameScene(6);
    }, this);

    this.EventCloseButton.button.once('click', function (event) {
        loadScene(`Menu`, { hierarchy: true, settings: true });
    }, this);

};

MiniGamesUi.prototype.checkLevelStatusForGame = function () {


    if (detectCurrentLevel()[0] == "Beginner") {

        this.EventsItems[0].button.active = true;
        this.EventsItems[0].element.useInput = true;
        this.EventsItems[0].children[0].children[0].enabled = false;
        this.EventsItems[0].children[0].children[1].children[2].enabled = false;

    }
    else if (detectCurrentLevel()[0] == "Advanced") {

        this.EventsItems[0].button.active = true;
        this.EventsItems[1].button.active = true;
        this.EventsItems[0].element.useInput = true;
        this.EventsItems[1].element.useInput = true;
        this.EventsItems[0].children[0].children[0].enabled = false;
        this.EventsItems[1].children[0].children[0].enabled = false;
        this.EventsItems[0].children[0].children[1].children[2].enabled = false;
        this.EventsItems[1].children[0].children[1].children[2].enabled = false;

    }
    else if (detectCurrentLevel()[0] == "Competent") {

        this.EventsItems[0].button.active = true;
        this.EventsItems[1].button.active = true;
        this.EventsItems[2].button.active = true;
        this.EventsItems[0].element.useInput = true;
        this.EventsItems[1].element.useInput = true;
        this.EventsItems[2].element.useInput = true;
        this.EventsItems[0].children[0].children[0].enabled = false;
        this.EventsItems[1].children[0].children[0].enabled = false;
        this.EventsItems[2].children[0].children[0].enabled = false;
        this.EventsItems[0].children[0].children[1].children[2].enabled = false;
        this.EventsItems[1].children[0].children[1].children[2].enabled = false;
        this.EventsItems[2].children[0].children[1].children[2].enabled = false;

    }
    else if (PlayerManager.instance.userData.userScore >= 5000){

        this.EventsItems[0].button.active = true;
        this.EventsItems[1].button.active = true;
        this.EventsItems[2].button.active = true;
        this.EventsItems[3].button.active = true;
        this.EventsItems[0].element.useInput = true;
        this.EventsItems[1].element.useInput = true;
        this.EventsItems[2].element.useInput = true;
        this.EventsItems[3].element.useInput = true;
        this.EventsItems[0].children[0].children[0].enabled = false;
        this.EventsItems[1].children[0].children[0].enabled = false;
        this.EventsItems[2].children[0].children[0].enabled = false;
        this.EventsItems[3].children[0].children[0].enabled = false;
        this.EventsItems[0].children[0].children[1].children[2].enabled = false;
        this.EventsItems[1].children[0].children[1].children[2].enabled = false;
        this.EventsItems[2].children[0].children[1].children[2].enabled = false;
        this.EventsItems[3].children[0].children[1].children[2].enabled = false;
    }
};
MiniGamesUi.prototype.loadMiniGameScene = function (miniGameIndex) {
    
    PlayerManager.instance.userData.gameMode = gamePlayMode.MiniGame;

    loadScene(`LoadingScene`, { hierarchy: true, settings: true }, () => {

        GameManager.instance.LoadEventData(miniGameIndex, function (preloadTag) {
            if (preloadTag != "") {
                PreloadManager.instance.loadMiniGameAssets(preloadTag, function (complete) {
                    if (complete) {
                        loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                            GameManager.instance.startMiniGame();
                        });
                    }
                });
            }
        });
    });
};


